import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
	// Initialize `isAuthenticated` based on localStorage directly
	const [isAuthenticated, setIsAuthenticated] = useState(() => {
		const token = localStorage.getItem("token");
		return !!token; // True if token exists, false otherwise
	});

	const login = (token) => {
		localStorage.setItem("token", token);
		setIsAuthenticated(true);
	};

	const logout = () => {
		localStorage.removeItem("token");
		setIsAuthenticated(false);
	};

	return (
		<AuthContext.Provider value={{ isAuthenticated, login, logout }}>
			{children}
		</AuthContext.Provider>
	);
}

export function useAuth() {
	return useContext(AuthContext);
}
